@import 'styles/mixins';
@import 'styles/variables';

.select {
  border-radius: 6px;
  border: 1px solid var(--neutral-10);
  background: var(--neutral-0);
  color: var(--neutral-90);
  height: 44px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.label {
  @include sm-medium;
  color: var(--neutral-40);
  margin-bottom: 4px;
}

.popover {
  width: 520px;
}
